<template>
	<div v-if="info">
    <van-cell-group inset>
      <van-cell title="申请人信息" value="" />
      <van-cell>
        <template #title>
          <p class="title flex"><span class="flex-s">申请人</span>{{info.realname}}</p>
          <p class="title flex"><span class="flex-s">手机号</span>{{info.mobile}}</p>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group inset>
      <van-cell title="会议信息" value="" />
      <van-cell>
        <template #title>
          <p class="title flex"><span class="flex-s">会议名称</span>{{info.meetingname}}</p>
          <p class="title flex"><span class="flex-s">开始时间</span>{{info.starttime}}</p>
          <p class="title flex"><span class="flex-s">结束时间</span>{{info.endtime}}</p>
          <p class="title flex" style="margin-bottom: 0.05rem"><span class="flex-s">地点</span>{{info.location}}</p>
		  <p class="title flex"><span class="flex-s" style="opacity: 0">地点</span>
			  <van-button type="info" plain round color="#5D6BFB" size="mini" @click="startSite">校准定位</van-button>
		  </p>
          <p class="title flex" v-if="info.remark"><span class="flex-s">备注</span>{{info.remark}}</p>
          <p class="title flex"  :class="{'green' : info.status == 1, 'black': info.status == 0 || info.status == 2}">
            <span class="flex-s">会议状态</span>{{info.status == 0 ? '未开始'
            : info.status == 1 ? '进行中' : '已结束'}}</p>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group inset>
      <van-cell title="升级礼包二维码" value="" />
      <div class="qrcode flex-jc-ac">
        <div>
          <img :src="info.status != 1 ? '/static/images/VIP/qrcode.png' : info.qrcodeimg">
          <p v-if="info.status == 1" class="color-9 f14">长按保存至手机</p>
        </div>
      </div>
    </van-cell-group>
  </div>
</template>

<script>
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import wx from "weixin-js-sdk";
export default {
  name: "meetingdetail",
  data () {
    return {
      info: null
    }
  },
  mounted() {
	  if (isWeixin()) {
		  fenxiang({path: 'meetingloginin'})
	  }
    this.getData()
  },
  methods: {
    getData () {
      var url = 'Wxmall/VipGift/getMeetInfo'
      this.$customRequestAjax(url).then(res => {
        if (res.data.code == 200) {
          this.info = res.data.data
          console.log(res.data)
        }
      })
    },
    startSite() {
      if (!isWeixin()) {
        this.$toast('请在微信使用此功能')
      }
      let that = this;
      wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function(res) {
          that.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          that.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          // var speed = res.speed; // 速度，以米/每秒计
          // var accuracy = res.accuracy; // 位置精度
          that.submit(res.longitude, res.latitude)
        }
      });
    },
    submit (lng, lat) {
      var url = 'Wxmall/VipGift/saveMeetinginfo', data = {
        realname: this.info.realname,
        mobile: this.info.mobile,
        meetingname: this.info.meetingname,
        starttime: this.info.starttime,
        endtime: this.info.endtime,
        province: this.info.province,
        city: this.info.city,
        area: this.info.area,
        address: this.info.location,
        lng: lng,
        lat: lat,
        remark: this.info.remark,
        loginmobile: sessionStorage.getItem('meetinglogin_mobile') ? sessionStorage.getItem('meetinglogin_mobile') : ''
      }
      this.$customRequestAjax.post(url, data).then(res => {
        if (res.data.code == 200) {
          this.$toast(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/common/css/createmeeting";
  .van-cell-group--inset {
    margin-top: 0.1rem;
    padding: 0.05rem 0;
  }
  .van-cell {
    padding-bottom: 0;
  }
  .van-cell::after {
    display: none;
  }
  .qrcode {
    margin: 0.2rem 0 0.1rem;
    img {
      width: 1.8rem;
      height: 1.8rem;
    }
    >div {
      position: relative;
    }

    p {
      text-align: center;
      margin-top: 0.1rem;
    }
  }
  .title {
    margin-bottom: 0.12rem;
    color: #333333;
    &.green {
      color: #32C25A;
    }
    &.black {
      font-weight: bold;
    }
    >span {
      width: 0.75rem;
      color: #666666;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/createmeeting/meetingdetail.vue